import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatThousands } from '../../../utils/formatter';

class StatisticsSideBar extends PureComponent {
    static propTypes = {
        totalCount: PropTypes.number.isRequired,
    };

    render() {
        return (
            <React.Fragment>
                <div className="panel">
                    <h3>Siste 14 dager</h3>

                    <p className="list-descriptive">
                        Besøkende:
                        <span className="u-float-right">
                            {formatThousands(this.props.totalCount)}
                        </span>
                    </p>

                    <p className="u-stone">
                        Med antall besøkende mener vi antall individuelle
                        personer som har besøkt bedriftsprofilen i løpet av
                        perioden.
                    </p>
                </div>

                <div className="panel panel--neutral">
                    <p>
                        <strong>Nyhet!</strong> Tydelig Profil trekker grafiske
                        elementer fra bedriftsprofilen inn i stillingsannonsen
                        og lenker inn til profilsiden.
                    </p>
                    <p>
                        Spør din kundekontakt om hvordan du kan få Tydelig
                        Profil på dine stillingsannonser.
                    </p>
                </div>
            </React.Fragment>
        );
    }
}

export default StatisticsSideBar;
